import { Actions } from '../actions/serverTokens';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IServerTokens } from '../interfaces/serverTokens';

export type State = DeepReadonly<{
  isFetching: boolean;
  gmapsIsLoaded: boolean;
  pendoIsLoaded: boolean;
  serverTokens: IServerTokens | null;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  gmapsIsLoaded: false,
  pendoIsLoaded: false,
  serverTokens: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_SERVER_TOKENS_REQUEST':
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case 'FETCH_SERVER_TOKENS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        serverTokens: action.payload,
        error: null
      };
    case 'FETCH_SERVER_TOKENS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case 'GMAPS_LOADED':
      return {
        ...state,
        gmapsIsLoaded: true
      };
    case 'PENDO_LOADED':
      return {
        ...state,
        pendoIsLoaded: true
      };
    case 'LOGOUT':
      return initialState;
    default:
      return state;
  }
}
